const bannerClasses =
  'flex items-start gap-3 mb-4 p-3 rounded-lg ' +
  'bg-danger-surface border border-danger/40 text-danger';

const iconClasses = 'fa fa-exclamation-triangle text-danger mt-0.5';

const FinalizeFailedBanner = () => (
  <div className={bannerClasses} role="alert">
    <i className={iconClasses} />
    <div>
      <p className="m-0 font-semibold text-sm">Last finalization failed</p>
      <p className="m-0 text-xs">
        We could not package the lifecare plan. Please try finalizing again.
      </p>
    </div>
  </div>
);

export default FinalizeFailedBanner;
